module.exports = __webpack_public_path__ + "img/logo_negativo_tagline2.27606358.png";